module.exports = __webpack_public_path__ + "static/img/yum.2657e28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/emoji/yum.png
// module id = SHLA
// module chunks = 0